"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _Clip = _interopRequireDefault(require("./Clip"));

var _immutable = require("immutable");

var _constants = require("composer-lib/lib/constants");

function parseClips(data) {
  var result = new _immutable.OrderedMap();
  data.forEach(function (item) {
    var clip = _Clip.default.fromJS(item);

    result = result.set(clip.get('id'), clip);
  });
  return result;
}

var DEFAULTS = {
  data: new _immutable.OrderedMap(),
  status: _constants.RequestStatus.UNINITIALIZED
};

var Clips = /*#__PURE__*/function (_Record) {
  (0, _inherits2.default)(Clips, _Record);

  function Clips() {
    (0, _classCallCheck2.default)(this, Clips);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Clips).apply(this, arguments));
  }

  (0, _createClass2.default)(Clips, null, [{
    key: "fromJS",
    value: function fromJS(data) {
      return new Clips({
        data: parseClips(data),
        status: _constants.RequestStatus.SUCCEEDED
      });
    }
  }]);
  return Clips;
}((0, _immutable.Record)(DEFAULTS));

exports.default = Clips;
module.exports = exports.default;